// extracted by mini-css-extract-plugin
module.exports = {"navigation":"payroll-review-di_navigation__1WOwM"};